import { render, staticRenderFns } from "./WealthProductTransaction.vue?vue&type=template&id=7f58dbac&scoped=true"
import script from "./WealthProductTransaction.vue?vue&type=script&lang=ts"
export * from "./WealthProductTransaction.vue?vue&type=script&lang=ts"
import style0 from "./WealthProductTransaction.vue?vue&type=style&index=0&id=7f58dbac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f58dbac",
  null
  
)

export default component.exports